<template>
  <div>
    <vuetable ref="vuetable" :api-url="url" :httpOptions="options" :fields="fields" pagination-path="" @vuetable:pagination-data="onPaginationData"></vuetable>

    <div class="vuetable-pagination ui basic segment grid">
      <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>

      <bulma-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></bulma-pagination>
    </div>
  </div>
</template>


<script>
import Vue from 'vue'
import TransActions from './TransActions'

Vue.component('trans-actions', TransActions)
import Vuetable from 'vuetable-2/src/components/Vuetable'
import BulmaPagination from './BulmaPagination'
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'

import url from '../utils/url'
import moment from 'moment'

export default {
  props: ["url"],
  components: {
    Vuetable, BulmaPagination, VuetablePaginationInfo
  },
  data() {
    return {
      options: {
        headers: { 'Authorization': window.localStorage.getItem('biyadmin') },
      },
      fields: [
        {
          name: '__sequence',   // <----
          title: '#'
        },
        {
          name: 'updatedAt',
          title: 'Date',
          callback: 'formatDate|DD/MMM HH:mm'
        },
        {
          name: 'status',
          title: 'Status',
          callback: 'statusLabel'
        },
        {
          name: 'reference',
          title: 'Reference'
        },
        {
          name: 'product',
          title: 'Product'
        },
        {
          name: 'identity',
          title: 'Identity',
          callback: 'identity'
        },
        {
          name: 'amount',
          title: 'Amount'
        },
        {
          name: 'user.name',
          title: 'Name'
        },
        {
          name: 'user.phone',
          title: 'Phone'
        },
        {
          name: '__component:trans-actions',   // <----
          title: 'Actions'
        }
      ]
    }
  },
  methods: {
    formatDate(value, fmt = 'D MMM YYYY') {
      return (value == null)
        ? ''
        : moment(value).format(fmt)
    },
    identity(value) {
      if (value.phone) {
        return value.phone
      } else if (value.customerNumber) {
        return value.customerNumber
      } else if (value.account) {
        return value.account
      } else if (value.accountNumber) {
        return value.accountNumber
      } else {
        return null
      }
    },
    statusLabel(value) {
      let labelled;
      switch (value) {
        case 'init':
          labelled = `<span class="tag is-light">Init</span>`
          break;
        case 'success':
          labelled = `<span class="tag is-success">Success</span>`
          break;
        case 'failed':
          labelled = `<span class="tag is-danger">Failed</span>`
          break;
        case 'pending':
          labelled = `<span class="tag is-warning">Pending</span>`
          break;
        default:
          labbelled = value
      }
      return labelled;
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page)
    }
  }
}
</script>


// WEBPACK FOOTER //
// TransTable.vue?78505ac4